import { APIError } from "@/api/client";

export function getAiirErrorMessage(error: unknown, action = "complete the request"): string {
  if (error instanceof APIError) {
    const responseMessage =
      typeof error.response?.error === "string"
        ? error.response.error
        : typeof error.response?.message === "string"
          ? error.response.message
          : undefined;

    if (error.status === 401) {
      return "You must be signed in to use Aiir.";
    }

    if (error.status === 403) {
      return "You do not have access to the selected Aiir workspace.";
    }

    if (error.status === 404) {
      return "The selected Aiir organization, product, or request was not found.";
    }

    if (error.status === 408 || error.status === 504) {
      return `Aiir timed out while trying to ${action}. Try again in a moment.`;
    }

    if (error.status === 429) {
      return responseMessage || "Aiir is being rate limited. Try again shortly.";
    }

    if (error.status >= 500) {
      return responseMessage || `Aiir backend failed while trying to ${action}.`;
    }

    return responseMessage || error.message || `Aiir could not ${action}.`;
  }

  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    if (
      message.includes("load failed") ||
      message.includes("failed to fetch") ||
      message.includes("networkerror") ||
      message.includes("network request failed") ||
      message.includes("network connection was lost") ||
      message.includes("could not connect")
    ) {
      return `Aiir could not reach the backend while trying to ${action}. Try again in a moment.`;
    }

    return error.message || `Aiir could not ${action}.`;
  }

  return `Aiir could not ${action}.`;
}
